import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Plus, Pencil, Users, ExternalLink, Trash2, Star } from "lucide-react";
import { InviteButton } from "../../components/site/InviteDialog";
import { useFetch } from "../../lib/useFetch";
import { api, errMsg, eur, fmtDate } from "../../lib/api";
import { StatusBadge } from "../../components/site/FileUpload";
import { AdminH } from "./AdminLayout";

export default function AdminEvents() {
  const { data, reload } = useFetch("/admin/events");
  const del = async (e) => {
    const n = e.capacity.registered + (e.capacity.waitlist || 0);
    if (!window.confirm(`Delete "${e.title}"?${n ? `\nIts ${n} registration(s) and related payments will be deleted too.` : ""}\nThis cannot be undone.`)) return;
    try {
      await api.delete(`/admin/events/${e.id}`);
      toast.success("Event deleted");
      reload();
    } catch (err) {
      toast.error(errMsg(err));
    }
  };
  return (
    <div data-testid="admin-events">
      <AdminH title="Clinics & Events" sub="Create, publish and monitor capacity">
        <Link to="/admin/events/new" className="btn-buoy !py-2.5" data-testid="events-add-button"><Plus size={16} />New event</Link>
      </AdminH>
      <div className="overflow-x-auto rounded-2xl border border-slate-200 bg-white">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-left text-xs uppercase tracking-wider text-slate-500">
            <tr><th className="px-4 py-3">Event</th><th className="px-4 py-3">Dates</th><th className="px-4 py-3">Location</th><th className="px-4 py-3">Fee</th><th className="px-4 py-3">Capacity</th><th className="px-4 py-3">Status</th><th /></tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {(data || []).map((e) => (
              <tr key={e.id} className="hover:bg-slate-50" data-testid={`event-row-${e.id}`}>
                <td className="px-4 py-3"><p className="font-semibold text-[#0A2540]">{e.title}</p><p className="text-xs text-slate-500">{e.type} · {(e.class_names || [e.class_name]).join(", ")}</p></td>
                <td className="whitespace-nowrap px-4 py-3">{fmtDate(e.start_date)} – {fmtDate(e.end_date)}</td>
                <td className="px-4 py-3">{e.location_name}</td>
                <td className="px-4 py-3">{eur(e.fee)}</td>
                <td className="px-4 py-3">
                  <span className={`font-semibold ${e.capacity.near_full ? "text-[#FF5722]" : ""}`}>{e.capacity.registered}/{e.capacity.max_participants || "∞"}</span>
                  {e.waitlist_enabled && <span className="block text-xs text-violet-600">WL {e.capacity.waitlist}/{e.waitlist_max}</span>}
                </td>
                <td className="px-4 py-3"><StatusBadge status={e.status} />{e.hidden && <span className="ml-2 rounded-full bg-rose-100 px-2 py-0.5 text-[10px] font-bold uppercase text-rose-700" data-testid={`event-hidden-badge-${e.id}`}>Hidden</span>}
                  {e.by_invitation && <span className="mt-1 flex flex-wrap items-center gap-2"><span className="inline-flex items-center gap-1 rounded-full bg-[#0A2540] px-2 py-0.5 text-[10px] font-bold uppercase text-[#FFC107]" data-testid={`event-invitation-badge-${e.id}`}><Star size={10} fill="#FFC107" />By invitation</span><InviteButton e={e} inline /></span>}</td>
                <td className="whitespace-nowrap px-4 py-3 text-right">
                  <Link to={`/admin/registrants?event_id=${e.id}`} className="mr-3 inline-block text-slate-400 hover:text-[#0A2540]" title="Registrants"><Users size={16} /></Link>
                  <a href={`/clinics/${e.id}`} target="_blank" rel="noreferrer" className="mr-3 inline-block text-slate-400 hover:text-[#0A2540]" title="Public page"><ExternalLink size={16} /></a>
                  <Link to={`/admin/events/${e.id}`} className="mr-3 inline-block text-slate-400 hover:text-[#0A2540]" data-testid={`event-edit-${e.id}`}><Pencil size={16} /></Link>
                  <button onClick={() => del(e)} className="text-slate-400 hover:text-rose-600" title="Delete" data-testid={`event-delete-${e.id}`}><Trash2 size={16} /></button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
